export default __webpack_public_path__ + "static/media/checkbox-colored.4aa81af9.svg";